import React from 'react'
import ButtonList from './ButtonList'
import VideoContainer from './VidoContainer'


const MainContainer = () => {
  return (
    <div className='mt-15' >

      {/* <ButtonList /> */}
      <VideoContainer />
    </div >

  )
}

export default MainContainer